import { Button, Modal } from 'antd'
import React from 'react'
import { GetData } from '../../api/service';

export default function HomePagePopupNews() {

    const [visible, setIsVisible] = React.useState(false)
    const [data, setData] = React.useState([]);
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        let timer = setTimeout(() => loadData(), 3000)
        return () => clearTimeout(timer)
    }, [])

    function loadData() {
        GetData(`/getpopupnewswebsite`)
            .then((resp) => {
                if (Array.isArray(resp) && resp.length > 0) {
                    setData(resp)
                    setActiveIndex(0)
                    setIsLoaded(true)
                    setIsVisible(true)
                }
            })
            .catch(() => null)
    }

    const activeData = data[activeIndex];

    if (!isLoaded || !activeData) {
        return null;
    }

    const hasMultiple = data.length > 1;

    // upload_info and upload_info_url hold the same files in the same order
    const files = Array.isArray(activeData?.upload_info_url) ? activeData.upload_info_url.map((url, index) => {
        let info = Array.isArray(activeData?.upload_info) ? activeData.upload_info[index] : {};
        let ext = info && info.ext ? String(info.ext).toLowerCase() : String(url).split('.').pop().toLowerCase();
        let mime = info && info.mime ? String(info.mime).toLowerCase() : '';

        return {
            url,
            isPdf: ext === 'pdf' || mime === 'application/pdf',
            isImage: mime.indexOf('image/') === 0 || ['jpg', 'jpeg', 'png', 'gif', 'webp'].indexOf(ext) > -1
        }
    }) : [];

    const images = files.filter((el) => el.isImage);
    const pdfs = files.filter((el) => el.isPdf);

    return (
        <div>
            <Modal
                title={activeData?.title}
                width={pdfs.length > 0 ? 800 : 520}
                visible={visible}
                onOk={() => null}
                onCancel={() => setIsVisible(false)}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            {hasMultiple && <span style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }}>
                                {activeIndex + 1} / {data.length}
                            </span>}
                        </div>
                        <div>
                            {activeData?.link ? <Button
                                type="primary"
                                href={activeData?.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Read More
                            </Button> : null}
                            &nbsp;
                            {hasMultiple && activeIndex > 0 ? <Button
                                onClick={() => setActiveIndex(activeIndex - 1)}
                            >
                                Previous
                            </Button> : null}
                            &nbsp;
                            {hasMultiple && activeIndex < data.length - 1 ? <Button
                                onClick={() => setActiveIndex(activeIndex + 1)}
                            >
                                Next
                            </Button> : <Button
                                onClick={() => setIsVisible(false)}
                            >
                                Close
                            </Button>}
                        </div>
                    </div>
                }
            >
                {images.length > 0 && <img
                    src={images[0].url}
                    alt={activeData?.title}
                    style={{ width: "100%" }}
                />}
                <p dangerouslySetInnerHTML={{ __html: activeData?.description }}></p>

                {pdfs.length > 0 && <div>
                    <iframe
                        src={pdfs[0].url}
                        title={activeData?.title}
                        style={{ width: "100%", height: "60vh", border: "solid thin rgba(0,0,0,0.15)" }}
                    ></iframe>

                    <div style={{ marginTop: 10 }}>
                        {pdfs.map((el, index) => <Button
                            key={index}
                            type="link"
                            style={{ paddingLeft: 0 }}
                            href={el.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {pdfs.length > 1 ? `Open PDF ${index + 1}` : `Open / Download PDF`}
                        </Button>)}
                    </div>
                </div>}

                {activeData?.link ? <div style={{ marginBottom: 10 }}>
                    <a
                        href={activeData?.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-all' }}
                    >
                        {activeData?.link}
                    </a>
                </div> : null}
            </Modal>
        </div>
    )
}
